<!--suppress AngularUndefinedTag -->
<div>
  <div fxFlex fxLayout="row" fxLayoutGap="16px">
    <div *ngIf="sameReports.length > 1" class="report-list">
      <h3>Meerdere meldingen op deze locatie:</h3>
      <div *ngFor="let report of sameReports">
        <div (click)="$event.stopPropagation();loadData(report)" *ngIf="report.id === data.id" class="clickable">
          <strong>{{ report.created_at | date: 'dd-MM-yy HH:mm' }}</strong>
        </div>
        <div (click)="$event.stopPropagation();loadData(report)" *ngIf="report.id !== data.id" class="clickable">
          {{ report.created_at | date: 'dd-MM-yy HH:mm' }}
        </div>
      </div>
    </div>
    <div>
      <table style="min-width:300px;">
        <tr>
          <th>Datum melding:</th>
          <td>{{ data.created_at | date:'dd-MM-yy HH:mm' }}</td>
        </tr>
        <tr>
          <th>Locatie:</th>
          <td>{{ data.complaint.location }}</td>
        </tr>
        <tr>
          <th>Hoofdcategorie:</th>
          <td>{{ data.head_category.name }}</td>
        </tr>
        <tr>
          <th>Sub categorie:</th>
          <td>{{ data.sub_category.name }}</td>
        </tr>
      </table>
    </div>
  </div>
</div>
